export const getEmployeeInitials = (name: string): string => {
  const parts = name.split(' ');

  return parts
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};
